import React, { useState, useCallback, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Profile from "../img/workfolio-big.png";
import { HiOutlineCheckCircle } from "react-icons/hi";
import "./MemberOverviewPage.css";
var MemberOverviewPage = function MemberOverviewPage(props) {
  return /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: "text-center member-overview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "create-password-content"
  }, /*#__PURE__*/React.createElement(HiOutlineCheckCircle, {
    className: "create-password-content-success-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "fs-18 m-b-16 text-center create-password-reset-success-msg1"
  }, "Your account has been created successfully!"), /*#__PURE__*/React.createElement("p", {
    className: "fs-18 m-b-16 text-center create-password-reset-success-msg2"
  }, "Now you can download and install workfolio on your device. Use your email and the password you created to log into the app after installation."), /*#__PURE__*/React.createElement("p", {
    className: "fs-18 m-b-16 text-center create-password-reset-success-msg3"
  }, "Download installation file for your operating system"), /*#__PURE__*/React.createElement("div", {
    className: "fs-18 m-b-16 text-center create-password-download-file-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "fs-18 m-b-16 text-center create-password-download-file-windows"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-windows-10-50.webp",
    alt: "windows",
    className: "create-password-download-file-windows-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "create-password-download-file-windows-text"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio-public.s3.ap-south-1.amazonaws.com/Workfolio%20Setup%200.1.5.exe",
    target: "_blank",
    "data-saferedirecturl": "https://workfolio-public.s3.ap-south-1.amazonaws.com/Workfolio%20Setup%200.1.5.exe"
  }, "Download for Windows"))), /*#__PURE__*/React.createElement("span", {
    className: "fs-18 m-b-16 text-center create-password-download-file-mac"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-mac-client-90.webp",
    alt: "mac",
    className: "create-password-download-file-mac-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "create-password-download-file-mac-text"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio-public.s3.ap-south-1.amazonaws.com/workfolio-0.1.5.dmg",
    target: "_blank",
    "data-saferedirecturl": "https://workfolio-public.s3.ap-south-1.amazonaws.com/workfolio-0.1.5.dmg"
  }, "Download for Mac"))))));
};
export default MemberOverviewPage;